// Provide React Refresh runtime stubs for web (needed for react-native-gesture-handler)
if (typeof window !== 'undefined') {
  if (typeof window.$RefreshReg$ === 'undefined') {
    window.$RefreshReg$ = function() {};
  }
  if (typeof window.$RefreshSig$ === 'undefined') {
    window.$RefreshSig$ = function() {
      return function(type) {
        return type;
      };
    };
  }
}

// Provide global require polyfill for web (needed for @react-navigation/elements)
if (typeof window !== 'undefined' && typeof window.require === 'undefined') {
  // This will be provided by webpack, but we ensure it exists
  // The actual require is provided by webpack's module system
}

import 'react-native-gesture-handler';
import { registerRootComponent } from 'expo';

import App from './App';

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);

